/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeCheckinResponse } from '../../models/consignee-checkin-response';
import { KeyType } from '../../models/key-type';
import { PostConsigneeCheckinDeliveryNotesRequest } from '../../models/post-consignee-checkin-delivery-notes-request';

export interface PostConsigneeAddonsCheckinV3$Params {
  organizationSiteKey: KeyType;
      body: PostConsigneeCheckinDeliveryNotesRequest
}

export function postConsigneeAddonsCheckinV3(http: HttpClient, rootUrl: string, params: PostConsigneeAddonsCheckinV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeCheckinResponse>> {
  const rb = new RequestBuilder(rootUrl, postConsigneeAddonsCheckinV3.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeCheckinResponse>;
    })
  );
}

postConsigneeAddonsCheckinV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins';
